module.exports = __webpack_public_path__ + "static/media/OK_Button@3x.a50dd723.png";